// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-companies {
    text-align: center;
    width: 286px;
  }

  .social-proof-logo-companies {
    text-align: center;
    width: 240px;
  }

  .logo-jsj {
    height: 15px;
    margin-bottom: 20px;
    margin-right: 20px;
  }
  .logo-pepsi {
    height: 25px;
    margin-bottom: 20px;
  }
  .logo-dell {
    height: 40px;
    margin-right: 20px;
  }
  .logo-disney {
    height: 25px;
    margin-right: 20px;
  }
  .logo-coinbase {
    height: 40px;
  }
  .logo-rivian {
    height: 25px;
    margin-left: 20px;
  }
  .text-bottom {
    margin-top: 20px;
    color: #3176da;
    font-size: 15px;
    margin-bottom: 40px;
  }
  .bottom-line{
      width: 150px;
      align-items: center;
      margin-bottom: 40px;
  }
  .grey-text {
    color: grey;
  }

  .top-logo-header {
    margin-bottom: 32px;
  
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 160%;
    letter-spacing: 0.15px;
    color: #888888;

  }
  
  .text-bottom-social-proof {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 160%;
    text-align: center;
    letter-spacing: 0.15px;
    color: #2E6EDF;
  }

  .social-proof-logo-row {
    margin-bottom: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .social-proof-logo-pepsi {
    width: 47px;
    height: 47px;
    margin-right: 24px;
  }

  .social-proof-logo-dell {
    width: 64px;
    height: 22px;
  }

  .social-proof-logo-johnson {
    width: 143px;
    height: 26px;
    margin-right: 24px;
  }

  .social-proof-logo-volvo {
    width: 43px;
    height: 43px;
  }

  .social-proof-logo-reddit {
    width: 85px;
    height: 36px;
    margin-right: 24px;
  }

  .social-proof-logo-disney {
    width: 77px;
    height: 42px;
  }
  `, "",{"version":3,"sources":["webpack://./src/v3/components/RightSidebar/logoCompanies/styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;EACA;MACI,YAAY;MACZ,mBAAmB;MACnB,mBAAmB;EACvB;EACA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;;IAEnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;;EAEhB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd","sourcesContent":[".logo-companies {\n    text-align: center;\n    width: 286px;\n  }\n\n  .social-proof-logo-companies {\n    text-align: center;\n    width: 240px;\n  }\n\n  .logo-jsj {\n    height: 15px;\n    margin-bottom: 20px;\n    margin-right: 20px;\n  }\n  .logo-pepsi {\n    height: 25px;\n    margin-bottom: 20px;\n  }\n  .logo-dell {\n    height: 40px;\n    margin-right: 20px;\n  }\n  .logo-disney {\n    height: 25px;\n    margin-right: 20px;\n  }\n  .logo-coinbase {\n    height: 40px;\n  }\n  .logo-rivian {\n    height: 25px;\n    margin-left: 20px;\n  }\n  .text-bottom {\n    margin-top: 20px;\n    color: #3176da;\n    font-size: 15px;\n    margin-bottom: 40px;\n  }\n  .bottom-line{\n      width: 150px;\n      align-items: center;\n      margin-bottom: 40px;\n  }\n  .grey-text {\n    color: grey;\n  }\n\n  .top-logo-header {\n    margin-bottom: 32px;\n  \n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 160%;\n    letter-spacing: 0.15px;\n    color: #888888;\n\n  }\n  \n  .text-bottom-social-proof {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 160%;\n    text-align: center;\n    letter-spacing: 0.15px;\n    color: #2E6EDF;\n  }\n\n  .social-proof-logo-row {\n    margin-bottom: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .social-proof-logo-pepsi {\n    width: 47px;\n    height: 47px;\n    margin-right: 24px;\n  }\n\n  .social-proof-logo-dell {\n    width: 64px;\n    height: 22px;\n  }\n\n  .social-proof-logo-johnson {\n    width: 143px;\n    height: 26px;\n    margin-right: 24px;\n  }\n\n  .social-proof-logo-volvo {\n    width: 43px;\n    height: 43px;\n  }\n\n  .social-proof-logo-reddit {\n    width: 85px;\n    height: 36px;\n    margin-right: 24px;\n  }\n\n  .social-proof-logo-disney {\n    width: 77px;\n    height: 42px;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
